module.exports = __webpack_public_path__ + "img/Faroe Islands.d5f0901f.svg";